import { render, staticRenderFns } from "./DuplicateDeliverableDetail.vue?vue&type=template&id=35672004&scoped=true&"
import script from "./DuplicateDeliverableDetail.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableDetail.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableDetail.vue?vue&type=style&index=0&id=35672004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35672004",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35672004')) {
      api.createRecord('35672004', component.options)
    } else {
      api.reload('35672004', component.options)
    }
    module.hot.accept("./DuplicateDeliverableDetail.vue?vue&type=template&id=35672004&scoped=true&", function () {
      api.rerender('35672004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateDeliverableDetail.vue"
export default component.exports